import { all, call, takeLatest } from "redux-saga/effects";
import { toast } from "react-toastify";

import { getErrorMessage } from "../../../../../utils/sagasErrorHandler";
import { handleUpdateConfigData } from "../../../services/general/sagas";
import { sharedHistory } from "../../../../../routes/sharedHistory";
import { ROUTES_MAP } from "../../../../../routes/constants";
import { CONFIG_MANAGER_LIGHT_STEPS } from "../../../index";

import { updateConfigData } from "./actions";

function* handleUpdateConfigDataStepTwo({ payload }){
    try {
        yield handleUpdateConfigData(payload);

        yield call(toast.success, "The Config has been successfully updated");
        const { search } = window.location;

        sharedHistory.push(`${ROUTES_MAP.configManagerLite.path}/${CONFIG_MANAGER_LIGHT_STEPS.three}${search}`);
    } catch (error) {
        getErrorMessage(error);
    }
}

export function* stepSecondSagas() {
    yield all([
        yield takeLatest(updateConfigData, handleUpdateConfigDataStepTwo)
    ]);
}
